namespace _Ext {
    export class AuditLogColumns {
        static columnsKey = '_Ext.AuditLog';
    }
}
